export default __webpack_public_path__ + "static/media/deliverd.2298ac33.jpg";